import React from "react";
import { connect } from "react-redux";
import Logo from "../assets/img/logo.svg";

class Refresh extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={this.props.height100 ? "refresh-wrap height100" : "refresh-wrap"}>
                <img src={Logo} alt=""/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken,
        navigationWidth: state.hejhome.navigationWidth,
    }
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
});

Refresh = connect(mapStateToProps, mapDispatchToProps)(Refresh);

export default Refresh;
